module.exports = __webpack_public_path__ + "ca24167b6e0201d3b6f41aa2d15e5a00.svg";